// extracted by mini-css-extract-plugin
module.exports = {"content":"DeleteSmtpPanel_content__1t_m8"};